import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState
} from 'react-accessible-accordion';

import Search from '../Search';
import { Diary, Help, Heart, Gear, Logout, Plus } from '../icons';
import profileIcons from '../icons/profileIcons';

import './Header.css';

const MobileMenu = props => {
  const {
    isAuthenticated,
    menuItems,
    profile,
    menuClose,
    openModal,
    t,
    onChangeProfileClick,
    handleLogout
  } = props;

  return (
    <nav>
      {isAuthenticated && (
        <div className="header__secondary-item header__search-container">
          <Search menuClose={menuClose} />
        </div>
      )}
      <div className="header__secondary-nav--burger">
        {isAuthenticated && (
          <Fragment>
            <NavLink
              to="/diary"
              className="header__secondary-item--link-burger header__secondary-item--link-burger-with-icon"
              activeClassName="active"
              onClick={() => menuClose()}
            >
              <Diary width="32" height="32" viewBox="0 0 32 32" />
              <span className="header__secondary-item--link-burger-title">
                {t('nav.diary')}
              </span>
            </NavLink>

            <Accordion
              allowZeroExpanded
              className="header__secondary-accordion"
              // preExpanded={[this.expandedAccordionItem]}
            >
              <AccordionItem>
                <AccordionItemHeading
                  className="header__secondary-accordion-item-heading
                  header__secondary-accordion-item-heading-with-icon"
                >
                  <AccordionItemButton className="header__secondary-accordion-item-button">
                    <AccordionItemState>
                      {({ expanded }) => (
                        <div className="header__secondary-accordion-item-button-wrapper">
                          <Help
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            className={`header-button__account-greeting-icon icon-without-label__icon${
                              expanded ? '--invert-color' : ''
                            }`}
                          />
                          <span>Ask List</span>
                        </div>
                      )}
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel className="header__secondary-accordion-panel">
                  <NavLink
                    to="#"
                    className="header__secondary-item--link-burger"
                    onClick={e => {
                      menuClose();
                      openModal(e);
                    }}
                  >
                    <Plus
                      className="header__secondary-item--link-burger-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 48 48"
                      fill="white"
                    />
                    {t('askList.addAQuestion')}
                  </NavLink>
                  <NavLink
                    onClick={() => menuClose()}
                    className="header__secondary-item--link-burger"
                    to="/questions"
                  >
                    {t('askList.seeAllQuestions')}
                  </NavLink>
                </AccordionItemPanel>
              </AccordionItem>

              <AccordionItem>
                <AccordionItemHeading className="header__secondary-accordion-item-heading header__secondary-accordion-item-heading-with-icon">
                  <AccordionItemButton className="header__secondary-accordion-item-button">
                    <div className="header__secondary-accordion-item-button-wrapper">
                      {profile && profileIcons[profile.icon] ? (
                        <img
                          src={profileIcons[profile.icon]}
                          width="40"
                          height="40"
                          className="header-button__account-greeting-icon"
                          alt=""
                        />
                      ) : (
                        <Heart
                          width="4rem"
                          height="4rem"
                          className="header-button__account-greeting-icon"
                        />
                      )}
                      <span>Account</span>
                    </div>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel className="header__secondary-accordion-panel">
                  <NavLink
                    to="#"
                    className="header__secondary-item--link-burger"
                    onClick={() => {
                      onChangeProfileClick();
                      menuClose();
                    }}
                  >
                    <div>
                      {profile ? (
                        <div className="header__secondary-item--profile-name">
                          {profile.firstName}
                        </div>
                      ) : null}
                      {t('nav.changeProfile')}
                    </div>
                  </NavLink>
                  <NavLink
                    onClick={() => menuClose()}
                    className="header__secondary-item--link-burger"
                    to="/options"
                    activeClassName="active"
                  >
                    <Gear
                      className="header__secondary-item--link-burger-icon"
                      width="24"
                      height="24"
                      viewBox="0 0 32 32"
                      fill="white"
                    />
                    {t('nav.options')}
                  </NavLink>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </Fragment>
        )}

        {menuItems &&
          menuItems.map(value => (
            <NavLink
              onClick={() => menuClose()}
              className="header__secondary-item--link-burger header__secondary-item--link-burger-no-icon"
              to={value.url}
              key={value.ID}
            >
              {' '}
              {value.title}
            </NavLink>
          ))}

        {isAuthenticated && (
          <Fragment>
            <NavLink
              onClick={() => menuClose()}
              className="header__secondary-item--link-burger header__secondary-item--link-burger-no-icon"
              to="/glossary"
            >
              {t('nav.glossary')}
            </NavLink>

            <NavLink
              onClick={() => menuClose()}
              className="header__secondary-item--link-burger header__secondary-item--link-burger-no-icon"
              to="/videos"
            >
              Videos
            </NavLink>
          </Fragment>

        )}

        {isAuthenticated && (
          <NavLink
            to="#"
            className="header__secondary-item--link-burger header__secondary-item--link-burger-with-icon"
            onClick={() => {
              menuClose();
              handleLogout();
            }}
          >
            <Logout
              className="header-button__account-icon header-button__account-icon--logout"
              width="32"
              height="32"
              viewBox="0 0 32 32"
            />
            <span className="header__secondary-item--link-burger-title">
              {t('nav.logout')}
            </span>
          </NavLink>
        )}
      </div>
      <div className="header__secondary-nav--burger-legal">
        <div className="header__secondary-nav--burger-legal-links">
          <NavLink
            className="header__secondary-nav--burger-legal-link"
            exact
            to="/subpage/terms-of-service"
            onClick={() => menuClose()}
          >
            Terms of Service
          </NavLink>
          <NavLink
            className="header__secondary-nav--burger-legal-link"
            exact
            to="/subpage/privacy-and-confidentiality"
            onClick={() => menuClose()}
          >
            {t('nav.privacy')}
          </NavLink>
        </div>

        <p className="header__second-nav--burger-legal-copy">
          {t('nav.copyright').replace('2019', new Date().getFullYear())}
        </p>
      </div>
    </nav>
  );
};

MobileMenu.propTypes = {
  isAuthenticated: PropTypes.bool,
  menuItems: PropTypes.arrayOf(PropTypes.shape({})),
  profile: PropTypes.shape({
    firstName: PropTypes.string,
    icon: PropTypes.string
  }),
  menuClose: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  onChangeProfileClick: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired
};

MobileMenu.defaultProps = {
  isAuthenticated: false,
  menuItems: null,
  profile: null
};

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/components/Header/MobileMenu.js